import { useMutation, useQuery } from '@tanstack/react-query';

import { SubmitFeedbackDTO } from '../../types';
import {
  findFeedbackFormByEventId,
  findFeedbackResponseBySlug,
  submitFeedback,
  submitFeedbackWithoutSlug,
} from '../feedback';

export function useGetFeedbackResponse(slug: string | null) {
  return useQuery({
    queryKey: ['feedback-response', slug],
    queryFn: async () => findFeedbackResponseBySlug(slug as string),
    refetchOnWindowFocus: true,
    enabled: !!slug,
  });
}

export function useGetFeedbackFormByEventId(eventId: number, slug: string | null) {
  return useQuery({
    queryKey: ['feedback-form', eventId],
    queryFn: async () => findFeedbackFormByEventId(eventId),
    refetchOnWindowFocus: true,
    enabled: !!eventId && !slug,
  });
}

export function useSubmitFeedbackForm(eventId: number) {
  return useMutation({
    mutationFn: async (payload: SubmitFeedbackDTO) =>
      payload.slug.length > 0
        ? submitFeedback(payload)
        : submitFeedbackWithoutSlug(eventId, payload),
  });
}
